import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import ModalShell from '@/components/modal-shell';
import { Button } from '@/components/ui/button';

interface UnsavedChangesModalProps {
  onCancel: () => void;
  onLeave: () => void;
  onSaveAndLeave: () => void;
}

export default function UnsavedChangesModal({ onCancel, onLeave, onSaveAndLeave }: UnsavedChangesModalProps) {
  const { t } = useTranslation();
  return (
    <ModalShell title={t('modals.unsavedChanges.title')} onClose={onCancel} maxWidth='max-w-sm' bottomSheetOnPhone
      icon={<AlertTriangle aria-hidden='true' className='h-4 w-4 shrink-0 text-ws-warning-fg' />}>
      <div className='flex flex-col gap-6'>
        <p className='text-sm text-ws-muted'>{t('modals.unsavedChanges.message')}</p>
        <div className='flex flex-col gap-2'>
          <Button variant='primary' onClick={onSaveAndLeave} className='w-full'>
            {t('modals.unsavedChanges.saveAndLeave')}
          </Button>
          <Button onClick={onLeave} className='w-full'>
            {t('modals.unsavedChanges.leaveWithoutSaving')}
          </Button>
          {/* Third rank, below `secondary`: this is the "never mind" on a three-way choice, and
              the shell's own close button is the other way to reach it. */}
          <Button variant='subtle' onClick={onCancel} className='w-full'>
            {t('common.cancel')}
          </Button>
        </div>
      </div>
    </ModalShell>
  );
}
